import { PageHeader } from "components/ui";
import React from 'react'
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from 'components/buttonsComponent/StyledButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';
import GriEmpowerment from "../../assets/images/GriEmpowerment.png"


const CdpCompliance = () => {
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <PageHeader
                    title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
                />
            </Box>

            <Grid item xs={12}>
                <Box className="gri-header">
                    <NavigationButtons imageKey="CDP" title={"CDP Reporting"} activeStep={0} />
                </Box>
            </Grid>
            <Grid item xs={12} >
                <Box
                    sx={{
                        borderRadius: '8px',
                        padding: '24px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box sx={{ flex: 1 }} >
                        <Typography
                            className="mb-4"
                            variant="h6"
                            style={{
                                fontWeight: 700,
                                color: '#02462E',
                                mb: 3,
                                fontSize: "40px",
                                fontFamily: "DM Sans",
                                lineHeight: "38px",
                                letterSpacing: "-2%",
                            }}
                        >
                            The global standards for Environmental <br />sustainability.                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: { xs: 4, md: 8 },
                                flexWrap: 'wrap',
                            }}
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <CustomButton
                                    title="CDP  Compliances customization"
                                    route="/reporting/cdp/compliance/customization"
                                />
                                <CustomButton
                                    title="Auto-Select with AI"
                                    route="/reporting/cdp/compliance/autoselect-ai"
                                />
                            </Box>

                            {/* <Box
                                component="img"
                                src={GriEmpowerment}
                                alt="Gri Empowerment"
                                sx={{
                                    width: '192px',
                                    height: '202px',
                                    ml: { xs: 0, md: 4 },
                                    mt: { xs: 4, md: 0 },
                                    flexShrink: 0,
                                }}
                            /> */}
                        </Box>

                    </Box>
                </Box>
            </Grid>
        </>

    )
}

export default CdpCompliance